import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const equipmentDevolutionObject = z.object({
  id: z.string().uuid(),
  equipmentId: z.string().uuid(),
  loanId: z.string().uuid(),
  citizenId: z.string().uuid(),
  observation: z.string().nullish(),
  devolutionDate: dateOrIsoString(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
})

export type EquipmentDevolutionType = z.infer<typeof equipmentDevolutionObject>

export const propertyMap = {
  id: sql`equipment_devolution.id`,
  equipmentId: sql`equipment_devolution.equipment_id`,
  loanId: sql`equipment_devolution.loan_id`,
  citizenId: sql`equipment_devolution.citizen_id`,
  observation: sql`equipment_devolution.observation`,
  devolutionDate: sql`equipment_devolution.devolution_date`,
  sourceFilter: sql`equipment_devolution.source_filter`,
  clientId: sql`equipment_devolution.client_id`,
  insertUserId: sql`equipment_devolution.insert_user_id`,
  editUserId: sql`equipment_devolution.edit_user_id`,
  createdAt: sql`equipment_devolution.created_at`,
  updatedAt: sql`equipment_devolution.updated_at`,
}

export default equipmentDevolutionObject
